// extracted by mini-css-extract-plugin
export default {"PDFReportViewer__fontSizeRadioGroupContainer":"SubstitutePDFReportViewer_PDFReportViewer__fontSizeRadioGroupContainer__Ec7X4"};